import React from 'react';
import { Navigate } from 'react-router-dom';
import SuspensePage from '@/app/ui/SuspensePage';

const ProDashboard = React.lazy(() => import('@/pages/pro/ProDashboard'));
const ProProfile = React.lazy(() => import('@/pages/pro/ProProfile'));
const ProProjects = React.lazy(() => import('@/pages/pro/ProProjects'));
const ProRequests = React.lazy(() => import('@/pages/pro/ProRequests'));
const ProStatistics = React.lazy(() => import('@/pages/pro/ProStatistics'));
const ProMessages = React.lazy(() => import('@/pages/pro/ProMessages'));
const LoyaltyPage = React.lazy(() => import('@/pages/dashboard/LoyaltyPage'));
const FavoritesPage = React.lazy(() => import('@/pages/dashboard/FavoritesPage'));
const MyAnnoncesPage = React.lazy(() => import('@/pages/dashboard/MyAnnoncesPage'));
const AnnoncesPublicPage = React.lazy(() => import('@/pages/dashboard/AnnoncesPublicPage'));
const MyResponsesPage = React.lazy(() => import('@/pages/dashboard/MyResponsesPage'));
const MyPurchaseRequestsPage = React.lazy(() => import('@/pages/dashboard/MyPurchaseRequestsPage'));

const proRoutes = [
  { index: true, element: <Navigate to="/pro/dashboard" replace /> },
  {
    path: 'dashboard',
    element: (
      <SuspensePage>
        <ProDashboard />
      </SuspensePage>
    ),
  },
  {
    path: 'profile',
    element: (
      <SuspensePage>
        <ProProfile />
      </SuspensePage>
    ),
  },
  { path: 'boutique', element: <Navigate to="/catalogue" replace /> },
  {
    path: 'favoris',
    element: (
      <SuspensePage>
        <FavoritesPage />
      </SuspensePage>
    ),
  },
  {
    path: 'achats',
    element: (
      <SuspensePage>
        <MyPurchaseRequestsPage />
      </SuspensePage>
    ),
  },
  {
    path: 'fidelite',
    element: (
      <SuspensePage>
        <LoyaltyPage />
      </SuspensePage>
    ),
  },
  {
    path: 'mes-annonces',
    element: (
      <SuspensePage>
        <MyAnnoncesPage />
      </SuspensePage>
    ),
  },
  {
    path: 'annonces-publiques',
    element: (
      <SuspensePage>
        <AnnoncesPublicPage />
      </SuspensePage>
    ),
  },
  {
    path: 'mes-reponses',
    element: (
      <SuspensePage>
        <MyResponsesPage />
      </SuspensePage>
    ),
  },
  {
    path: 'messages',
    element: (
      <SuspensePage>
        <ProMessages />
      </SuspensePage>
    ),
  },
  {
    path: 'projects',
    element: (
      <SuspensePage>
        <ProProjects />
      </SuspensePage>
    ),
  },
  {
    path: 'requests',
    element: (
      <SuspensePage>
        <ProRequests />
      </SuspensePage>
    ),
  },
  {
    path: 'statistics',
    element: (
      <SuspensePage>
        <ProStatistics />
      </SuspensePage>
    ),
  },
];

export default proRoutes;
